export default "__VITE_ASSET__d2917000__"